// extracted by mini-css-extract-plugin
module.exports = {"mr_1":"ArticleId_mr_1__7MCYw","ArticleIdLabel":"ArticleId_ArticleIdLabel__3646K"};